import { OpbCompanySearchFilter } from '../../models/opbCompanySearchFilter';

export interface IOpbCompanyListState {
  searchFilter: OpbCompanySearchFilter;
  currentPage: number;
  pageSize: number;
  sortBy: string;
  ascending: boolean;
}

// `measurement` is intentionally omitted: the active business year is unknown at module-load time
// (the JS bundle parses before provideAppInitializer runs). The list component fills it in from
// the live ActiveYearService value on first load, then the store carries the user's selection.
export const initialOpbCompanyListState: IOpbCompanyListState = {
  searchFilter: { isActive: true, isTransferred: false },
  currentPage: 1,
  pageSize: 10,
  sortBy: 'name',
  ascending: true
};
